(function (angular) {
    angular
        .module('one.admin')
        .controller('MailTemplatesController', MailTemplatesController);

    MailTemplatesController.$inject = ['$scope', 'AuthService', 'MailService', 'TagService', 'dataframe', 'modal', 'session'];

    function MailTemplatesController($scope, AuthService, MailService, TagService, dataframe, modal, session) {
        $scope.templates = dataframe.init({
            externalData: MailService.templates,
            cols: [
                {
                    title: 'Title',
                    name: 'title',
                    display: function (row) {
                        return '<h4><i class="md-icon">palette</i> {{ row.title }} <i class="md-icon text-muted" uib-tooltip="{{ \'general.default\' | translate }}" ng-if="row.primary">check</i></h4>';
                    },
                    weight: 2,
                    sortable: true
                },
                {
                    title: 'Style',
                    name: 'default',
                    display: function (row) {
                        if (row.default) {
                            return '<span class="label label-success"><i class="md-icon">check_circle_outline</i> {{ \'general.optimized\' | translate }}</span>';
                        }

                        return '<span class="label label-default"><i class="md-icon">code</i> {{ \'general.custom\' | translate }}</span>';
                    },
                    weight: 1,
                    sortable: true
                },
                {
                    title: 'Tags',
                    name: 'tags',
                    display: function (row) {
                        return ' <span tag-indicator tags="row.tags"></span>';
                    },
                    weight: 1
                },
                {
                    title: 'Mails',
                    name: 'mails',
                    display: function (row) {
                        return '{{ row.mail_count | number }}'
                    },
                    weight: 1
                }
            ],
            rowOptions: [
                {
                    title: 'Edit',
                    icon: 'edit',
                    sref: function (row) {
                        return 'mail.templates.editMailTemplate({mailTemplateId: ' + row.id + '})';
                    },
                    visible: function (row) {
                        return AuthService.userCanAccess('mail_templates.edit');
                    }
                },
                {
                    title: 'Duplicate',
                    icon: 'flip_to_front',
                    click: function (row) {
                        $scope.templates.loading = true;

                        MailService.duplicateMailTemplate(row).then(function () {
                            $scope.templates.getData()
                        });
                    },
                    visible: function (row) {
                        return row.duplicatable && AuthService.userCanAccess('mail_templates.add');
                    }
                },
                {
                    title: 'Delete',
                    icon: 'delete',
                    click: function (row) {
                        openDeleteMailTemplateModal(row.id);
                    },
                    visible: function (row) {
                        return row.deletable && AuthService.userCanAccess('mail_templates.delete');
                    }
                }
            ],
            rowSref: function (row) {
                if (AuthService.userCanAccess('mail_templates.edit')) {
                    return 'mail.templates.editMailTemplate({mailTemplateId: ' + row.id + '})';
                }
                return false;
            },
            state: session.get('data.dataframes.templates', {
                sort: { title: 'asc' },
                filters: {
                    tags: session.get('data.dataframe.tags', [])
                }
            })
        });

        if (AuthService.userCanAccess('tags.toggle')) {
            TagService.insertDataframeTags($scope.templates, 'mail_template', session.get('data.tags'));
        }

        session.sync('data.dataframes.templates', $scope.templates.state);

        $scope.openAddMailTemplateModal = openAddMailTemplateModal;
        $scope.openDeleteMailTemplateModal = openDeleteMailTemplateModal;

        function openAddMailTemplateModal(size) {
            modal.open('addMailTemplate', size).result.then(function (data) {
                $scope.templates.getData();
            });
        }

        function openDeleteMailTemplateModal(id) {
            modal.open('confirm', null, { title: 'Are you sure?', message: 'Delete this mail template?' }).result.then(function (data) {
                deleteMailTemplate(id);
            });
        }

        function deleteMailTemplate(id) {
            MailService.deleteMailTemplate(id).then(function (data) {
                $scope.templates.getData();
            });
        }
    }
})(angular);
